// extracted by mini-css-extract-plugin
export default {"edgeButton":"ComponentEdgeEditMode_edgeButton__HSIMF"};